export default __webpack_public_path__ + "static/media/home.282f9006.png";